<template>
  <div class="page-wrapper">
    <div style="width: 100%; height: 50px;">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-left" style="height: 50px; line-height: 50px;">
            <date-picker v-model="dateRange" valueType="format" @change="dateRangeSelected" range></date-picker>


            <button class="btn btn-success" @click="getManifests">불러오기</button>

            <button class="btn btn-primary" @click="getAvailableManifests">진행중인 목록</button>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; height: calc(100% - 50px); overflow-y: auto;">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <table class="table">
              <tr>
                <th>#</th>
                <th class="manifest-state-col">상태</th>
                <th>Shipping Mode</th>
                <th class="text-left">BK No</th>
                <th>MBL</th>
                <th>Cntr No</th>
                <th>ETD</th>
                <th>ETA</th>
              </tr>
              <tbody >
              <tr v-for="(item, index) in items" v-on:click="openManifestItem(item.id)" v-bind:class="[{'dist-row': item.state >= 0 && item.state < 100},{'completed-request-row': item.state === 100}]">
                <td>{{index+1}}</td>
                <td class="manifest-state-col"><span v-if="item.state === 100">완료</span><span v-else>진행중</span></td>
                <td>{{item.shippingMode}}</td>
                <td class="text-left">{{item.bkNo}}</td>
                <td><span v-if="item.shippingMode === 'AIR OUT'">{{item.awb}}</span><span v-else>{{item.mblNo}}</span></td>
                <td>
                  <span v-if="item.shippingMode == 'AIR OUT'"></span>
                  <span v-else>{{item.containerNumber}}</span>

                </td>
                <td>
                  <span v-if="item.shippingMode === 'AIR OUT'">{{item.signedDate}}</span>
                  <span v-else>{{item.etd}}</span>
                </td>
                <td>
                  <span v-if="item.shippingMode === 'AIR OUT'">{{item.arrivalTime}}</span>
                  <span v-else>{{item.eta}}</span>

                </td>
              </tr>
              </tbody>

            </table>

          </div>
<!--          <div class="col-12 col-md-6 col-lg-4" v-for="item in items">-->
<!--            <div class="manifest-card-item" v-on:click="openManifestItem(item.id)">-->
<!--              <div style="height: 30px; line-height: 30px; font-size: 20px;">-->
<!--                BK No: {{item.bkNo}}-->
<!--              </div>-->
<!--              <div style="height: 30px; line-height: 30px; font-size: 20px;">-->

<!--                ETD: {{item.etd}} <span v-if="item.eta !== null && item.eta.length > 0">ETA: {{item.eta}}</span>-->
<!--              </div>-->
<!--              <div style="min-height: 30px; line-height: 30px; font-size: 20px;">-->
<!--                MBL No: {{item.mblNo}} Cnt Np: {{item.containerNumber}}-->
<!--              </div>-->
<!--              <div style="min-height: 30px; line-height: 30px; font-size: 20px;">-->
<!--                <span v-if="item.cbm > 0">{{item.cbm}}CBM</span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </div>
    <div style="position: fixed; cursor: pointer; bottom: 20px; right: 20px; padding: 10px; background-color: #C4EACF; color:black; font-weight: bold; border-radius: 10px; box-shadow: 3px 3px 5px gray;"
         v-if="editItem === false" v-on:click="showShippingModeSelector = true">
      추가하기
    </div>
    <transition name="vertical">
      <manifest-item-view v-if="editItem !== false"
                          :item="editItem"
                          :customers="customers"
                          :on-updated="onManifestUpdated"
                          :on-close="onManifestClosed"
                          :on-deleted="onManifestDeleted">

      </manifest-item-view>
    </transition>
    <transition name="vertical">
      <air-manifest-view v-if="editAirItem !== false"
                         :item="editAirItem"
                         :customers="customers"
                         :on-updated="onManifestUpdated"
                         :on-closed="onManifestClosed"
                         :on-deleted="onManifestDeleted">
      </air-manifest-view>
    </transition>
    <div style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.4);" v-if="showShippingModeSelector === true" @click="showShippingModeSelector = false">
      <div style="position:absolute; top: 50%; left: 50%; width: 500px; transform: translate(-50%, -50%); background: white; border-radius: 20px; overflow: hidden;" @click.stop="dummy">
        <div style="height: 80px; width: 100%; font-size: 20px; line-height: 80px; font-weight: bold; text-align: center; background: #24a6a4; color:white;">
          Select Shipping Mode
        </div>
        <div class="shipping-mode-selector-item" v-for="m in shippingModeList" :key="'shipping-mode-selector-item-' + m" @click="addNewManifest(m)">{{m}}</div>

      </div>

    </div>
  </div>
</template>

<script>
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import RequestItemView from "./RequestItemView";
  import ManifestItemView from "./ManifestItemView";
  import AirManifestView from "./AirManifestView.vue";
  import {millisToDate, showDialog} from "../api/utils";
  import {createNewManifest, getAvailableManifests, getManifest, getManifests, updateManifest} from "../api/manifests";
  import {getCustomers, getCustomer} from "../api/customers";
  import {getShippingMode} from "../api/request";
  export default {
    name: "Manifests",
    data() {
      return {
        dateRange:null,
        items:[],
        editItem:false,
        editAirItem: false,
        customers:[],
        showShippingModeSelector:false,
        shippingModeList:getShippingMode(),
      }
    },
    components: {
      RequestItemView,
      DatePicker,
      ManifestItemView,
      AirManifestView
    },
    created() {
    },
    mounted() {
      this.getCustomerList();
      this.getAvailableManifests();
    },
    methods: {
      dummy: function() {

      },
      dateRangeSelected: function() {
        console.log("dateRangeSelected")
        console.log(this.$data.dateRange)

        if(this.$data.dateRange.length !== 2) {
          return;
        }

        if(this.$data.dateRange[0] > this.$data.dateRange[1]) {
          let temp = this.$data.dateRange[1];
          this.$data.dateRange[0] = this.$data.dateRange[1];
          this.$data.dateRange[1] = temp;
        }

      },
      getCustomerList: function() {
        let self = this;
        getCustomers()
          .then(function(data){
            console.log("Customer list");
            console.log(data);
            if(data.success === true) {
              self.$data.customers = data.item;
            }
            self.searchList();
          })
          .catch(function(err) {

          })
      },
      addNewManifest: function(mode) {
        this.$data.showShippingModeSelector = false;
        let item = createNewManifest();
        item.shippingMode = mode;
        if(mode === 'AIR OUT') {
          item.shipper = 'UKO SHIPPING LTD';
          item.shipperAddress = 'Unit 7 Caker Stream Road';
          item.shipperAddress2 = 'Alton, GU34 2QA, ENGLAND';
          item.shipperAddress3 = 'UNITED KINGDOM';
          item.shipperTel = '+44 1420 430 750';

          item.carrierAgentName = 'UKO SHIPPING LTD';
          item.carrierAgentAddress = 'TEL: +44 01420 430 750'
        }
        let self = this;
        updateManifest(item)
        .then(function(data) {
          if(data.success === true) {
            if(data.item.shippingMode === 'AIR OUT') {

              self.$data.editAirItem = data.item;
            } else {
              self.$data.editItem = data.item;
            }
          } else {
            showDialog(data.message || 'Failed to save manifest.', 'ERROR');
          }
        })
        .catch(function (err) {
          showDialog((err && err.message) ? err.message : 'Failed to save manifest.', 'ERROR');
        })
      },
      onManifestUpdated: function(item) {
        let found = false;
        for(let i = 0 ; i < this.$data.items.length ; i++) {
          if(this.$data.items[i].id === item.id) {
            if(item.state === 100 || item.state < 0 || item.deleted === true) {
              this.$data.items.splice(i, 1);
              return;
            } else {
              this.$data.items.splice(i, 1, item);
              found = true;
              return;
            }

          }
        }

        if(found === false) {
          this.$data.items.push(item);
        }
      },
      onManifestClosed: function() {
        this.$data.editAirItem = false;
        this.$data.editItem = false;
      },
      onManifestDeleted: function(item) {
        for(let i = 0 ; i < this.$data.items.length ; i++) {
          if(this.$data.items[i].id == item.id) {
            this.$data.items.splice(i, 1);
            break;
          }
        }
      },
      getManifests: function() {
        if(this.$data.dateRange.length !== 2) {
          return;
        }
        // let date = this.$data.dateRange[0];
        this.$data.items = [];
        let self = this;
        getManifests(this.$data.dateRange[0], this.$data.dateRange[1])
        .then(function(data) {
          if(data.success === true) {
            data.item.sort(function(a, b) {
              if(a.eta > b.eta) {
                return 1;
              } else if(a.eta < b.eta) {
                return -1;
              }
              return 0;
            })
            self.$data.items = data.item;
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
      },
      getAvailableManifests: function() {

        // let date = millisToDate(new Date().getTime());
        this.$data.items = [];
        let self = this;
        getAvailableManifests(0, 99)
        .then(function(data) {
          if(data.success === true) {
            data.item.sort(function(a, b) {
              if(a.eta > b.eta) {
                return 1;
              } else if(a.eta < b.eta) {
                return -1;
              }
              return 0;
            })
            self.$data.items = data.item;
          }
        })
        .catch(function(err) {
          let msg = err;
          console.log(err);
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
      },

      openManifestItem: function(id) {
        let self = this;
        getManifest(id)
        .then(function(data) {
          if(data.success === true) {
            console.log(data.item);
            if(data.item.shippingMode === 'AIR IN' || data.item.shippingMode === 'AIR OUT') {
              self.$data.editAirItem = data.item;
              console.log(self.$data.editAirItem);
            } else {
              self.$data.editItem = data.item;
            }
          } else {
            showDialog(data.message || 'Failed to load manifest.', 'ERROR');
          }
        })
        .catch(function(err) {
          showDialog((err && err.message) ? err.message : 'Failed to load manifest.', 'ERROR');
        })
      },
      getManifestList: function() {
        if(this.$data.dateRange == null || this.$data.dateRange.length !== 2) {
          showDialog("Please select date range");
          return;
        }

        this.$data.items = [];
        let self = this;
        getManifests(this.$data.dateRange[0], this.$data.dateRange[1])
        .then(function(data) {
          if(data.success === true) {
            self.$data.items = data.item;
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
      }
    }
  }
</script>

<style scoped>
.shipping-mode-selector-item {
  height: 80px;
  width: 100%;
  line-height: 80px;
  border-top: 1px solid #dadada;
  cursor: pointer;
  font-weight: bold;
}
.shipping-mode-selector-item:hover {
  background: #dadada;
}
.manifest-state-col {
  white-space: nowrap;
  width: 1%;
  min-width: 4.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/Manifests.vue